var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('v-overlay',{attrs:{"value":_vm.loading,"dark":""}},[_c('CubeShadow',{attrs:{"size":"70px","background":"#e9e9ea"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }